//import { contacts } from './../Dropdown';
import { ProgramPanelType, Signature } from '../eligibility/types';
import { DateString } from '../../utils/type';
import { RadioButtonData } from '../../components/formlib/CustomRadioButton';
import { v4 as uuidv4 } from 'uuid';
import { TableData } from '../ifsp/ServiceDeliveryPlan';
import { HeadCell } from '../../components/formlib/TableHeader';
import { StatusType } from '../activitySheet/ActivityTableRow';
import { ServicePlanType } from '../../redux/features/ifsp/ifspSDPAndConsentSlice';

export const EvaluationQuestions: RadioButtonData[] = [
  {
    value: 'BDI 2',
    labelId: 'BDI',
    defaultLabel: 'BDI',
  },
  {
    value: 'Other Assessment',
    labelId: 'Other Assessment',
    defaultLabel: 'Other Assessment',
  },
];

export const DayCareQuestions: RadioButtonData[] = [
  {
    value: 'yes',
    labelId: 'Clientpage.RadiolabelA',
    defaultLabel: 'Yes',
  },
  {
    value: 'no',
    labelId: 'Clientpage.RadiolabelB',
    defaultLabel: 'No',
  },
];

export const LEAReferralReasons: RadioButtonData[] = [
  {
    value: 'leaReason1',
    labelId: 'leaReason1',
    defaultLabel: 'Family moved to another town within catchment area',
  },
  {
    value: 'leaReason2',
    labelId: 'leaReason2',
    defaultLabel: 'Parent consent not provided within timeframe',
  },
  {
    value: 'leaReason3',
    labelId: 'leaReason3',
    defaultLabel: 'Parent initiated referral',
  },
  {
    value: 'leaReason4',
    labelId: 'leaReason4',
    defaultLabel: 'Other',
  },
];

export interface CheckboxType {
  id: string;
  labelId: string;
  defaultLabelId: string;
  isChecked: boolean;
}

export const headCells: HeadCell<TableData>[] = [
  {
    id: 'eiService',
    labelId: 'EI Service/Method',
    defaultLabelId: 'EI Service/Method',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'providedBy',
    labelId: 'Provided by',
    defaultLabelId: 'Provided By',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'locationOfService',
    labelId: 'Location of Service',
    defaultLabelId: 'Location of Service',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'freqperlen',
    labelId: 'IFSP.FreqPerLen',
    defaultLabelId: 'Freq, Per, Len',
    numeric: false,
    requiredSorting: false,
  },
  // {
  //   id: 'length',
  //   labelId: 'length',
  //   defaultLabelId: 'Length',
  //   numeric: false,
  //   requiredSorting: false,
  // },
  // {
  //   id: 'period',
  //   labelId: 'period',
  //   defaultLabelId: 'Period',
  //   numeric: false,
  //   requiredSorting: false,
  // },
  // {
  //   id: 'frequency',
  //   labelId: 'Frequency & Length',
  //   defaultLabelId: 'Frequency & Length',
  //   numeric: false,
  //   requiredSorting: false,
  // },
  {
    id: 'intensity',
    labelId: 'Intensity',
    defaultLabelId: 'Intensity',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'duration',
    labelId: 'Duration of Service',
    defaultLabelId: 'Duration of Service',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'startDate',
    labelId: 'Start Date',
    defaultLabelId: 'Start Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'endDate',
    labelId: 'End Date',
    defaultLabelId: 'End Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'reason',
    labelId: 'Reason',
    defaultLabelId: 'Reason',
    numeric: false,
    requiredSorting: false,
  },
];

export const LEAProblems: CheckboxType[] = [
  {
    id: uuidv4(),
    labelId: 'otText',
    defaultLabelId: 'OT',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'ptText',
    defaultLabelId: 'PT',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'speechText',
    defaultLabelId: 'Speech',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'cognitionText',
    defaultLabelId: 'Cognition',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'behaviorText',
    defaultLabelId: 'Behavior',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'visionText',
    defaultLabelId: 'Vision',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'hearingText',
    defaultLabelId: 'Hearing',
    isChecked: false,
  },
  {
    id: uuidv4(),
    labelId: 'grossMotorText',
    defaultLabelId: 'Gross Motor',
    isChecked: false,
  },
  {
    id: 'other',
    labelId: 'otherText',
    defaultLabelId: 'Other',
    isChecked: false,
  },
];

export interface LEAQuestion {
  id: string;
  question: string;
  answer: string;
}
export interface ConsentClientSignature {
  id: string;
  name: string;
  firstName?: string;
  lastName?: string;
  relationship: string;
  email: string;
  signature: string;
  verbal: boolean;
  date?: string | null;
  paperConsent: boolean;
  consentSignedDate?: string | null;
  license?: string;
  rowKey?: string;
  partitionKey?: string;
  isPrimary: boolean;
  isLegal: boolean;
  isGuardian: boolean;
  isLatest?: boolean;
}

export interface LEAReferralType extends ProgramPanelType {
  type: string | null;
  referralDate: DateString;
  requestedDate: string | null;
  dischargeReason: string | null;
  daysThirdBirth: number | null;
  referralReason: string | null;
  referralReasonOther: string | null;
  referringTo: string | null;
  currentIssues: string | null;
  currentOtherIssues: string | null;
  evaluationFrom: string | null;
  lastEvaluationDate: DateString;
  attachBDI2Results: boolean | null;
  other: boolean | null;

  otherText: string | null;
  attachIFSP: boolean | null;
  childIsInDayCare: boolean | null;
  dayCareName: string | null;
  dayCarePhoneNumber: string | null;
  childSchedule: string | null;
  dayCareAddress: string | null;
  otherReleventInfo: string | null;
  areasOfConcern: {
    adaptive: string | null;
    communication: string | null;
    socialEmotional: string | null;
    motor: string | null;
    cognitive: string | null;
    vision: string | null;
    hearing: string | null;
    otherConcern: string | null;
    behavior: string | null;
  };
  earlyInterventionService: ServicePlanType[];
  questionnaire: LEAQuestion[];
  employeeSignature: Signature | null;
  parentSignature: Signature | null;
  tpc: {
    date: DateString;
    time: string | null;
    location: string | null;
  };
  consentId: string;
  leaConsentSigned: boolean;
  lastUpdatedByInfo?: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  signature: ConsentClientSignature[];
  contact: ConsentClientContact[];
  selectedContact: string[];
  signedDate: string | Date | null;
  authorizationStatus: string;
  revokedDate: string | null;
  revokeSignature: ConsentClientSignature | null;
  refusal: boolean;
  createdOn: string;
  modifiedOn: string;
  createdBy: string;
  modifiedBy: string;
  interpreterNeeded: string | null;
  birthPlaceCity: string | null;
  birthPlaceState: string | null;
  childResidesWith: string | null;
  requester: ConsentRequester;
  uiVersion: number | null;
  parent: {
    address: string | null;
    contactId: string | null;
    email: string | null;
    homePhoneNumber: string | null;
    isPrimary: boolean;
    name: string | null;
    relationshipToClient: string;
    type: string | null;
  };
}
export interface ConsentRequester {
  name: string;
  email: string;
  phone: string;
}

export interface ConsentClientContact {
  id: string;
  name: string;
  address: string | null;
  email: string;
  phone: string;
  type?: string;
  isGuardian: boolean;
  isPrimary: boolean;
  isLegalGuardian: boolean;
  selectedContact?: string[];
  signature?: ConsentClientSignature[];
  signedDate?: string | Date | null;
  contact?: ConsentClientContact[];
}
export interface SimilarClient {
  clientId: string;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  suffix: string | null;
  sex: string | null;
  dateOfBirth: string | null;
  dphId: string | null;
  programId: string | null;
  programName: string | null;
  programAcronym: string | null;
  status: StatusType;
  isChecked: boolean;
  referralBeginDate: string | null;
  referralEndDate: string | null;
}
